_             = require('underscore')
util          = require('./util')
rollbarHelper = require('shared/util/error/rollbar')
config        = require('shared/util/error/config')

module.exports =

  install: (Vue, options = {}) ->
    _oldOnError = Vue.config.errorHandler

    Vue.config.errorHandler = (error, vm, info) ->
      error._isReported = true
      message = "#{message} #{if vm? then util.formatLocation(util.formatComponentName(vm)) else ''}"

      if config.environment != 'production'
        message = "Error in #{info}:"
        util.vueWarn("[Vue]: #{message}", vm)

      rollbarHelper.reportError("[Vue]", message, error.stack, error)

      if _.isFunction(_oldOnError)
        _oldOnError.call(@, error, vm, info)
      else
        console.error error, ' in ', vm





// WEBPACK FOOTER //
// ./assets/js/shared/plugins/vue_rollbar/index.coffee